import React from "react";
import DayPicker from "react-day-picker";
import "react-day-picker/lib/style.css";
import "react-daterange-picker/dist/css/react-calendar.css";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import CheckIcon from "@material-ui/icons/Check";
import SwapVert from '@material-ui/icons/SwapVert';

const styles = {
  paper: {
    textAlign: "center"
  },
  button: {
    width: "90%",
    marginLeft: "5%",
    marginTop: "5%",
    fontSize: '0.7rem'
  },
  formControl: {
    maxWidth: 23
  },
  divider: {
    width: 1,
    height: 28,
    marginLeft: 70,
    marginRight: 10
  },
  root: {
    width: "100%",
    minWidth: 250
  }
};

const dateNames = [
  "Custom",
  "Today",
  "Yesterday",
  "Last month",
  "Last 7 days",
  "Last 30 days",
  "Last 90 days"
];

class DatePicker extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      anchorEl: null,
      selectedIndex: 1
    };
  }

  handleListItemClick = (event, index) => {
    const { handleListItemClick } = this.props;
    const { selectedIndex } = this.state;
    this.setState({selectedIndex: index});
    handleListItemClick(index, selectedIndex);
    this.handleClose()
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleDayClick = day => {
    if (day > (new Date()) && day.toLocaleDateString() !== (new Date()).toLocaleDateString()) return;
    const {handleDayClick} = this.props;
    handleDayClick(day);
    this.setState({selectedIndex: 0});
  }

  render() {
    const { classes, from, to, modifiers } = this.props;
    const { anchorEl, selectedIndex } = this.state;
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    const modifiersStyles = {
      start: {
        color: 'black',
        backgroundColor: '#009673',
      },
      end: {
        color: 'black',
        backgroundColor: '#009673',
      }
    };

    const options = (
      <div className={classes.root}>
        <List component="nav" aria-label="secondary mailbox folder">
          {dateNames.map((date, index) => (
            <div key={date}>
              <ListItem
                button
                selected={selectedIndex === index}
                onClick={event => this.handleListItemClick(event, index)}
              >
                <ListItemText primary={date} />
                {selectedIndex === index && (
                  <ListItemIcon>
                    <CheckIcon />
                  </ListItemIcon>
                )}
              </ListItem>
              <Divider />
            </div>
          ))}
        </List>
      </div>
    );
    return (
      <Paper className={classes.paper}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Button
              aria-describedby={id}
              variant="outlined"
              onClick={this.handleClick}
              className={classes.button}
              color="primary"
            >
              Date Range: {dateNames[selectedIndex]} <SwapVert className={classes.icon} color="primary"/>
            </Button>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={this.handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center"
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center"
              }}
            >
              {options}
            </Popover>
          </Grid>
          <Grid item xs={12}>
            <DayPicker
              className="Selectable"
              selectedDays={[from, { from, to }]}
              modifiers={modifiers}
              onDayClick={this.handleDayClick}
              modifiersStyles={modifiersStyles}
              disabledDays={day => day > (new Date()) && day.toLocaleDateString() !== (new Date()).toLocaleDateString()}
              showOutsideDays
            />
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export default withStyles(styles)(DatePicker);
